/**
 * `buildRowNodePk` — single fix-point for the FK Breadcrumb's cross-table
 * drill-down callbacks (EP6 mini-grid → reverse-FK drill).
 *
 * Concern 2 wired the referencing table's full PK metadata through the
 * inbound-FK payload (`InboundRelation.targetPkColumns`). Both drill call
 * sites (same-table SRV + cross-table SRV) now pass that array in, so the
 * pushed row-node carries the complete composite PK and "Open in QE" emits
 * the full multi-column WHERE.
 *
 * Falls back to the legacy first-column heuristic when `pkColumns` is empty
 * (older snapshots / un-enriched paths). Returns `null` when the row has no
 * columns at all — callers should treat `null` as "skip the row push".
 */

export type RowPk = ReadonlyArray<{ readonly column: string; readonly value: unknown }>;

export function buildRowNodePk(
  row: Record<string, unknown>,
  pkColumns: ReadonlyArray<string>,
): RowPk | null {
  // Concern 2 — prefer the enriched composite-PK metadata. Fall back to
  // "first column wins" only when the backend didn't surface PK columns.
  const columns = pkColumns.length > 0 ? pkColumns : Object.keys(row).slice(0, 1);
  if (columns.length === 0) return null;
  return columns.map((column) => ({ column, value: row[column] }));
}
